import { createAction, createAsyncAction } from 'typesafe-actions'
import SummaryData from '../../../entities/SummaryData'

export const fetchSummary = createAction('CMD / Summary / fetch')()

export const fetchSummaryAsync = createAsyncAction(
    'EVT / Summary / fetch request',
    'EVT / Summary / fetch success',
    'EVT / Summary / fetch failure',
)<undefined, SummaryData, Error>()

export const setSummaryState = createAction('DOC / Summary / set state')<SummaryData>()
